


















































import { Component } from "vue-property-decorator";
import { Base } from "@/components/common/base";
import { PaginationModel, VHeaders } from "@/models/pagedlistmodel";
import { fileBunkerService } from "@/shared";
import { attachmentService } from "@/shared";

@Component({
  components: {
    AppGrid: () => import("@/components/common/app.grid.vue"),
    Calendar: () => import("@/components/common/app.calendar.vue"),
    SnackBarLoader: () => import("@/components/common/loader.vue")
  }
})
class FileBunkerStatusDashboardPage extends Base {

  public loading = false;
  public pagination = new PaginationModel("createdAt", true);
  public childPagination = new PaginationModel("", true, -1);
  public calendarKey = 0;
  public params = { startDate: "", endDate: "" };
  public resetFilter: boolean = false;
  public isFileViewing: boolean = false;
  public fromServerSearch = false;
  public headers: VHeaders[] = [];
  public pagedPayment: any[] = [];
  public filterPagedPayment: any[] = [];
  public actions: any[] = [];
  public modelFilter: string = "In Progress";

  public filtersItems = [
    { value: null, text: "All" },
    { value: "Completed", text: "Completed" },
    { value: "In Progress", text: "In Progress" },
    { value: "Error", text: "Error" },
    { value: "Orphan", text: "Orphan" }
  ];
  public setParentHeaders() {
    this.headers = [
      {
        text: '',
        value: '',
        isNotDataProp: true,
        align: 'center',
        width: '80px'
      },
      { text: "Directory Type", value: "directoryType", align: "center" },

      { text: "Original File Name", value: "originalFileName", align: "center" },

      { text: "Pages", value: "pageCount", align: "center" },
      {
        text: "Status",
        value: "isSuccess",
        fieldType: "template",
        template: i => {
          const status = this.getParentStatus(i);

          const color =
            status === "In Progress" ? "warning" :
              status === "Error" ? "error" :
                status === "Orphan" ? "deep-orange" :
                  "success";

          return `<v-chip small text-color="white" :color="'${color}'">${status}</v-chip>`;
        }
      },


      { text: "Created At", value: "createdAt", sortable: true, fieldType: "date" },
      { text: "Updated At", value: "updatedAt", sortable: true, fieldType: "date" }
    ];
  }


  public paymentResponseHeaders: VHeaders[] = [
    {
      align: 'left',
      text: 'Action',
      isNotDataProp: true,
      sortable: false,
    },

    { text: "File Name", value: "sourceFilePath", align: "center" },
    { text: "Record Key", value: "recordKey" },
    { text: "Metadata Type", value: "metadataType" },
    { text: "Key Identifier", value: "keyIdentifier", align: "center" },
    {
      text: "Status",
      value: "isSuccess",
      fieldType: "template",
      template: i => {


        let label = "Completed";
        let color = "success";
        if (i.isInProgress) {
          label = "In Progress";
          color = "warning";
        }
        else if (i.metadataType === "Error") {
          label = "Error";
          color = "error";
        }
        else if (i.metadataType === "Orphan") {
          label = "Orphan";
          color = "deep-orange";
        }

        return `
      <v-chip small text-color="white" :color="'${color}'">
        ${label}
      </v-chip>
    `;
      }
    },
    { text: "Pages", value: "pageCount", align: "center" },
    { text: "Created At", value: "createdAt", sortable: true, fieldType: "date" },
    {
      text: "Remarks",
      fieldType: "template",
      template: i => {

        let message = "";

        if (i.metadataType === "Orphan" && !i.recordKey) {
          message = `${i.directoryType} number could not be extracted from the PDF.`;
        }
        else if (i.metadataType === "Orphan" && i.recordKey) {
          message = `No matching ${i.directoryType} record was found.`;
        }

        return message
          ? `<span class="deep-orange--text font-weight-medium">${message}</span>`
          : "";
      }
    }

  ];



  public async mounted(): Promise<void> {
    this.setParentHeaders();
    this.pagination.rowsPerPage = 10;
    this.$root.$emit('sidebar.layout.vue', 'fileBunkerDashboard');
    this.setDefaultDateRange();
    await this.getPayments().then(() => {
      this.applyClientFilters();
    });
    this.setActions();
    this.setParentHeaders();

  }



  public async getPayments(): Promise<void> {
    this.loading = true;

    try {
      const response = await fileBunkerService.getFileBunkerLogs(
        this.params?.startDate ?? "",
        this.params?.endDate ?? ""
      );

      const safeData = Array.isArray(response) ? response : [];

      const nested = this.buildNestedGrid(safeData);


      this.pagedPayment = (nested ?? []).map(parent => {
        const keys = (parent.children || [])
          .map(c => String(c.recordKey || ""))
          .filter(Boolean);

        return {
          ...parent,
          recordKeySearch: keys.join(" "),
          recordKeyDisplay: keys.join("\n")
        };
      });

      this.filterPagedPayment = [...this.pagedPayment];
      this.pagination.totalItems = this.pagedPayment.length;
      this.applyClientFilters();
    }
    catch (error) {
      console.error("getPayments failed:", error);
      this.pagedPayment = [];
      this.filterPagedPayment = [];
      this.pagination.totalItems = 0;
    }
    finally {
      this.loading = false;
    }
  }

  private buildNestedGrid(data: any[]): any[] {
    const groups: Record<string, any[]> = {};

    data.forEach(item => {
      const key = item.blobBackupFilePath || 'UNKNOWN';
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });
    const result: any[] = [];

    Object.values(groups).forEach(group => {
      group.sort(
        (a, b) =>
          new Date(a.createdAt).getTime() -
          new Date(b.createdAt).getTime()
      );

      const parent = { ...group[0], children: [] };

      parent.children =
        group.length === 1
          ? group.map(item => ({ ...item }))
          : group.slice(1).map(item => ({ ...item }));

      const keys = parent.children
        .map(c => String(c.recordKey || ""))
        .filter(Boolean);

      parent.recordKeySearch = keys.join(" ");
      parent.recordKeyDisplay = keys.join("\n");

      result.push(parent);
    });

    return result;
  }

  public getPaymentResponse(payment: any) {
    return payment.paymentResponses || [];
  }

  public updatePaging(paging: any): void {
    this.pagination = paging;
  }
  public async searchPayments(): Promise<void> {
    this.$nextTick(() => this.applyClientFilters());
    this.pagination.page = 1;
    this.loading = true;
    this.fromServerSearch = true;
    // var searchVal = this.pagination.search;
    try {
      const response = await fileBunkerService.getFileBunkerLogs(
        this.params.startDate,
        this.params.endDate,
        this.pagination.search
      );
      this.pagination.search = "";
      const nested = this.buildNestedGrid(response || []);
      this.pagedPayment = nested;
      this.filterPagedPayment = nested;
      this.pagination.totalItems = nested.length;
      this.applyClientFilters();
      this.setActions();
      this.setParentHeaders();


    } finally {
      this.loading = false;
      // this.pagination.search = searchVal;

    }
  }

  public async resetAttachmentsReport(): Promise<void> {
    this.fromServerSearch = false;
    this.pagination.page = 1;
    this.pagination.search = "";
    this.modelFilter = null;

    this.setDefaultDateRange();
    this.calendarKey++;

    await this.getPayments();
  }

  public setDefaultDateRange() {
    const t = new Date();
    const y = new Date(); y.setDate(t.getDate() - 1);
    this.params.startDate = this.formatDate(y);
    this.params.endDate = this.formatDate(t);
    this.calendarKey++;

  }
  private viewFileAlertShown = false;

  public setActions() {
    this.actions = [
      {
        type: "button",
        icon: "fas fa-eye",
        title: this.$parent.$t(
          "scannedInvoices.gridHeaders.gridAction.view"
        ) as string,
        loading: false,
        action: (model: any, action: any) => {
          var fileUri = model.isInProgress ? model.blobBackupFilePath : model.destinationPath;
          this.openAttachment(fileUri, action);
        },
      },
    ];
  }

  public async openAttachment(uri: string, action: any): Promise<void> {
    if (!uri) {
      this.showAlert(false, this.$t("epicorAttachments.UriNotFound"));
      return;
    }

    this.isFileViewing = true;


    try {
      action.loading = true;
      await this.$nextTick();
      var blobName = uri?.replace("/privatedocs/", "");
      await attachmentService.viewAttachmentByUriAsync(blobName, true);

    } catch (e) {
      this.showAlert(false, "Unable to retrieve file.");
    } finally {
      this.isFileViewing = false;
      action.loading = false;
    }
  }


  public applyClientFilters(): void {
    let rows = Array.isArray(this.pagedPayment) ? [...this.pagedPayment] : [];

    const filterSearch = this.pagination?.search?.trim()?.toLowerCase() || "";

    if (filterSearch) {
      rows = rows
        .filter(parent =>
          parent?.originalFileName?.toLowerCase().includes(filterSearch) ||
          parent?.keyIdentifier?.toLowerCase().includes(filterSearch) ||
          parent?.sourceFilePath?.toLowerCase().includes(filterSearch) ||
          parent?.children?.some(child =>
            String(child?.recordKey || "").toLowerCase().includes(filterSearch)
          )
        )
        .map(parent => {
          const matchedChildren = (parent.children || []).filter(child =>
            String(child?.recordKey || "").toLowerCase().includes(filterSearch)
          );

          const parentMatch =
            parent?.originalFileName?.toLowerCase().includes(filterSearch) ||
            parent?.keyIdentifier?.toLowerCase().includes(filterSearch) ||
            parent?.sourceFilePath?.toLowerCase().includes(filterSearch);

          return {
            ...parent,
            //  if parent matches → keep ALL children
            //  else → keep only matched children
            children: parentMatch ? (parent.children || []) : matchedChildren
          };
        });
    }

    if (this.modelFilter) {
      rows = rows.filter(x => this.getParentStatus(x) === this.modelFilter);
    }

    this.filterPagedPayment = rows;
    this.pagination.totalItems = rows.length;
  }

  public setInvoiceDateParmsGlAccount(dates: any): void {
    if (!dates) return;

    let fromDate = "";
    let endDate = "";

    if (typeof dates === "object" && !Array.isArray(dates)) {
      fromDate = dates?.fromDate || "";
      endDate = dates?.endDate || "";
    }

    if (Array.isArray(dates)) {
      fromDate = dates?.[0] || "";
      endDate = dates?.[1] || "";
    }

    if (!fromDate || !endDate) return;

    this.params.startDate = fromDate;
    this.params.endDate = endDate;
  }


  private formatDate(d: Date) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  }
  private getParentStatus(row: any): string {
    const children = row?.children || [];

    if (row.isInProgress) return "In Progress";
    if (children.some(c => c.metadataType === "Error")) return "Error";
    if (children.some(c => c.metadataType === "Orphan")) return "Orphan";

    return "Completed";
  }
}
export default FileBunkerStatusDashboardPage;
